/// amarildo lacerda
import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
  selector: 'mat-select-month',
  template: `
    <mat-form-field>
      <mat-select [(ngModel)]="ano_mes">
        <mat-option *ngFor="let option of options" (click)="doClick($event)" [value]="option.data">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MatSelectMonthComponent),
      multi: true
    }
  ]

})

export class MatSelectMonthComponent implements ControlValueAccessor {
  meses: Array<string> = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
  options: Array<any> = [];
  selected: string;
  ano_mes = { ano: 0, mes: 0 };
  _data: Date = new Date();
  constructor() { }
  @Output() change = new EventEmitter();
  propagateChange = (_: any) => { };

  @Input()
  get value(){
    return this._data;
  }
  set value(d:Date){
    this.data = d;
  }
  @Input()
  get data() {
    return this._data;
  }
  set data(x: Date) {
    if (x != null) {
      let a = x.getFullYear();
      let m = x.getMonth()+1;
      let r = { ano: a, mes: m };
      if (( this.ano_mes.ano!=a) && (this.ano_mes.mes != m)) {
        this._data = x;
        this.ano_mes = r;
        this.doClick(r);
      }
    }
  }
  @Input()
  get year(){
    return this.ano_mes.ano;
  }
  set year(x:number){
    this.ano_mes.ano = x;
    this.doClick(this.ano_mes);
  }
  @Input()
  get month(){
    return this.ano_mes.mes;
  }
  set month(x:number){
    this.ano_mes.mes = x;
    this.doClick(this.ano_mes);
  }
  writeValue(obj: any): void {
    if (obj !== undefined) {
      this.ano_mes = obj;
    }
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.registerOnTouched = fn;
  };

  doClick(opt) {
    if (this.change != null) {
      this.change.emit(this.ano_mes);
    }
  }

  getExt(ano, mes) {
    return this.meses[mes - 1] + '/' + ano.toFixed(0).substring(2);
  }

  ngOnInit() {
    let ano: number = new Date().getFullYear();
    let mes: number = new Date().getMonth() + 1;


    this.selected = this.getExt(ano, mes);
    for (let i = 0; i < 48; i++) {
      let value = { ano: ano, mes: mes };
      let label = this.getExt(ano, mes);
      this.options.push({ label: label, value: i, data: value })
      mes--;
      if (mes < 1) {
        mes = 12;
        ano--;
      }
    }
    this.ano_mes = this.options[0].data;

    if (this.change != null) {
      this.change.emit(this.ano_mes);
    }
  }
}
